module.exports = __webpack_public_path__ + "static/media/sv.c89f544d.svg";